
import BackgroundGrid from "@/components/global/BackgroundGrid";

export default {
  components: {BackgroundGrid},
};
